import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";

export default function CustomModal({
  isOpen,
  toggle,
  title,
  body,
  onConfirm,
  onConfirmColor,
  onConfirmText,
}) {
  const confirmButton = onConfirmText ? (
    <>
      {" "}
      <Button color={onConfirmColor} onClick={onConfirm}>
        {onConfirmText}
      </Button>
    </>
  ) : (
    <></>
  );
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>{body}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Anuluj
        </Button>
        {confirmButton}
      </ModalFooter>
    </Modal>
  );
}
